import { render, staticRenderFns } from "./RegisterTotpApp.vue?vue&type=template&id=46047055&scoped=true&"
import script from "./RegisterTotpApp.vue?vue&type=script&lang=js&"
export * from "./RegisterTotpApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46047055",
  null
  
)

export default component.exports